export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6329.ec88a374.jpg";